import { Route, Router, Switch } from "react-router-dom";
import {
  bssoRoutes,
  deepblueRoutes,
  errorPageRoutes
} from "./index";

import AuthLayout from "../layouts/Auth";
import DeepBlueLayout from "../layouts/DeepBlue";
import Error404 from "../pages/errors/404";
import history from "./history";

import { FullStory, isInitialized } from "@fullstory/browser";
import Session from "components/LM/Auth/Session";
import ScrollToTop from "../components/ScrollToTop";

const childRoutes = (Layout, routes) =>
  routes.map(({ children, name: parentName, path, component: Component, exact }, index) =>
    children ? (
      // Route item with children
      children.map(({ name: childrenName, path, component: Component }, index) => (
        <Route
          key={index}
          path={path}
          exact={exact === false ? false : true}
          render={props => {
            setDocumentTitle(`${parentName} ${childrenName}`);
            return (<Layout><Component {...props} /></Layout>)
          }
          }
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        exact={exact === false ? false : true}
        render={props => {
          setDocumentTitle(parentName)
          return (<Layout><Component {...props} /></Layout>)
        }
        }
      />
    )
  );

const setDocumentTitle = (title) => {
  const documentTitle = `${title} - DeepBlue`;
  document.title = documentTitle;

  identifyFullStory(documentTitle);
}

const identifyFullStory = (pageName) => {
  const session = new Session().get();
  if (isInitialized() && session) {
    FullStory("setIdentity", {
      uid: session.user.id,
      properties: {
        displayName: session.user.name,
        page: pageName,
        product: "DEEPBLUE",
        reviewsWritten_int: 14
      }
    })
  }
}

const Routes = () => (
  <Router history={history}>
    <ScrollToTop>
      <Switch>
        {childRoutes(AuthLayout, errorPageRoutes)}
        {childRoutes(AuthLayout, bssoRoutes)}
        {childRoutes(DeepBlueLayout, deepblueRoutes)}
        <Route
          render={() => {
            setDocumentTitle("Page not found");
            return (<AuthLayout><Error404 /></AuthLayout>);
          }}
        />
      </Switch>
    </ScrollToTop>
  </Router>
);

export default Routes;
